export default __webpack_public_path__ + "4a198b1f6b8d8ab540f1f8b3aeaa88eb.svg";